<div layout="row">
	<div fxFlex>
		<pp-professional-dashboard></pp-professional-dashboard>
	</div>
</div>
